// Cannot use rankingsEntity type due to circular dependency issue
export const sortAdp = (p: { adp: number }) => p.adp
